import { render, staticRenderFns } from "./VehicleShareIcon.vue?vue&type=template&id=270242a6&scoped=true&"
import script from "./VehicleShareIcon.vue?vue&type=script&lang=js&"
export * from "./VehicleShareIcon.vue?vue&type=script&lang=js&"
import style0 from "./VehicleShareIcon.vue?vue&type=style&index=0&id=270242a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270242a6",
  null
  
)

export default component.exports